import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import jQuery from 'jquery'
import vSelect from "vue-select"
import datePicker from 'vuejs-datepicker'
import Axios from 'axios'
import Swal from 'sweetalert2'
import VueHtmlToPaper from 'vue-html-to-paper'
import QrcodeVue from 'qrcode.vue'
import VueTheMask from 'vue-the-mask'
import "vue-select/dist/vue-select.css"
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import highcharts from 'highcharts-vue'
import introJs from 'intro.js';
import 'intro.js/introjs.css';
global.jQuery = jQuery
global.$ = jQuery

// Configurar tour globalmente
Vue.prototype.$intro = () => {
   return introJs().setOptions({
      nextLabel: 'Próximo',
      prevLabel: 'Anterior',
      doneLabel: 'Concluir',
      disableInteraction: true,
      keyboardNavigation: false,
      // showProgress: true,
      showBullets: true,
      exitOnOverlayClick: false
   })
}

Vue.prototype.$axios = Axios
Vue.prototype.$toast = Swal.mixin({
   toast: true,
   position: 'top-end',
   showConfirmButton: false,
   timer: 3500,
   timerProgressBar: true,
   didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
   }
})

Vue.directive('focus', {
   inserted: function (el) {
      el.focus()
   }
})

require("@/assets/vendor/bootstrap/css/bootstrap.min.css")
require("@/assets/vendor/font-awesome/css/font-awesome.css")
require("@/assets/bundles/vendorscripts.bundle.js")
require("@/assets/css/mooli.min.css")

Vue.use(highcharts)
Vue.use(VueTheMask)
Vue.use(VueHtmlToPaper)
Vue.component(Cropper)
Vue.component('qrcode-vue', QrcodeVue)
Vue.component("v-select", vSelect)
Vue.component("datePicker", datePicker)

Vue.config.productionTip = false

new Vue({
   router,
   store,
   render: h => h(App)
}).$mount('#app')
